import './PriceBlock.scss';

import { b2x } from '@b2x/react/src';

export type PriceBlockProps = b2x.PriceBlockProps;

export const PriceBlock = ({ alignItems, classNames, ...otherProps }: PriceBlockProps) => {
  return (
    <b2x.PriceBlock
      {...otherProps}
      alignItems={alignItems ? alignItems : 'center'}
      classNames={{
        crossedOutPrice: `text-gray-400 ${classNames?.crossedOutPrice}`,
        discountPercentage: `px-2 bg-promo text-white d-flex align-items-center rounded-1 text-uppercase small ${classNames?.discountPercentage}`,
        price: `fw-bold text-black ${classNames?.price}`,
        specialPrice: `fw-bold text-black ${classNames?.specialPrice}`,
      }}
    />
  );
};
